// extracted by mini-css-extract-plugin
export default {"list":"energy_list__fAG4j"};